_         = require 'lodash'
ubBanzai  = require 'ub/control/banzai-features'

# Right now this module is only being used to manage the UI binding and
# lifecycle of image scaling dialogs. TODO: Extend this to cover more editor
# dialogs, so their lifecycles can all be managed from one place.

rootRoutingKey = 'Dialog'

class DialogManager

  constructor: ->
    @currentDialog = null

    # Create UI bindings
    @_uiBindings =
      imageScaling: new window.rxUi.Binding [rootRoutingKey, 'ImageScaling']

    # Subscribe UI bindings to their handlers
    imageScalingHandler = window.lp.module.image.ImageElement.scalingDialogUIBindingHandler
    @_uiBindings.imageScaling.ub_subscribe imageScalingHandler


  getUIBinding: (dialogName) ->
    @_uiBindings[dialogName]


  isDialogOpen: ->
    Boolean @currentDialog


  getCurrentDialog: ->
    @currentDialog

  openDialog: (dialog, additionalProps = {}) ->
    if _.isFunction dialog?.open
      @closeCurrentDialog() if @isDialogOpen()

      @currentDialog = _.merge({dialog: dialog}, additionalProps)

      @currentDialog.dialog.open(additionalProps.elm, additionalProps.options)

    else if ubBanzai.features.isDebugModeEnabled()
      console.warn 'Dialog does not have an `open` method.'


  closeCurrentDialog: ->
    if @currentDialog and _.isFunction @currentDialog.dialog?.close
      @currentDialog.dialog.close()
      @currentDialog = null
    else if ubBanzai.features.isDebugModeEnabled()
      console.warn 'Trying to close dialog, but no dialog is open.'


module.exports = DialogManager



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/dialog-manager.coffee